import axios from "axios"
import baseURL from "../configs/api"

export const getBranches = (tenantId: string) => {
    return getFetch("branch", tenantId)
}

export const getBranchesWithTimeZoneValue = (tenantId: string) => {
    return getFetch("branch/GetBranchesWithTimeZoneValue", tenantId)
}

export const getBranch = (primaryKey: string, tenantId: string) => {
    return getFetch(`branch/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}
